<template>
  <modal class="invites-repeated-modal" @close="$emit('close')" :redesign="true">
    <div slot="header">
      {{ $tr('invites.repeatedModal.title') }}
    </div>
    <div slot="body">
      <p class="repeated-description"> {{ $tr('invites.repeatedModal.description') }} </p>

      <div class="list-wrapper">
        <div class="row-block header">
          <div class="cell cell-checkbox row-checkbox">
            <vchecklabel
              class="checkbox-block"
              v-model="selectedAll"/>
          </div>
          <div class="cell"> {{ $tr('invites.repeatedModal.email') }} </div>
          <div class="cell"> {{ $tr('invites.repeatedModal.date') }} </div>
          <div class="cell"> {{ $tr('invites.repeatedModal.vacancy') }} </div>
          <div class="cell"> {{ $tr('invites.repeatedModal.sender') }} </div>
        </div>

        <div class="scrollable">
          <div 
            v-for="(v, index) in invites"
            :key="`${v.localId}_${v.created_at}`"
            class="row-block"
          >
            <div class="cell cell-checkbox">
              <!-- Show in a row only unique e-mails (hide if above this line we have exact another email) -->
              <template v-if="!(index > 0 && invites[index - 1].candidate.email === v.candidate.email)">
                <input type="checkbox" class="checkbox" :value="v.localId" v-model="selected" :id="`invite_${v.localId}`"/>
                <label :for="`invite_${v.localId}`"></label>
              </template>
            </div>
            <div class="cell" :title="v.candidate.email">
              <!-- Show in a row only unique e-mails (hide if above this line we have exact another email) -->
              <span v-if="!(index > 0 && invites[index - 1].candidate.email === v.candidate.email)">
                {{ v.candidate.email }}
              </span>
            </div>
            <div class="cell" :title="createdAt(v)">
              <span> {{ createdAt(v) }} </span>
            </div>
            <div class="cell" :title="v.vacancy.title">
              <span> {{ v.vacancy.title }} </span>
            </div>
            <div
              class="cell"
              :title="manager(v) || '-'"
              :class="{'centered': !manager(v)}"
            >
              <span> {{ manager(v) || '-' }} </span>
            </div>
          </div>
        </div>
      </div>

      <div class="row-block">
        <span v-show="selected.length > 0">{{ hint }}</span>

        <vbutton
          color="transparent"
          text_color="grey"
          label="invites.repeatedModal.deleteRepeated"
          :disabled="selected.length === 0"
          @click="deleteSelected" />
      </div>
    </div>
    
    <div slot="footer" class="footer">
      <p class="subscript">{{ $tr('invites.repeatedModal.subscript') }}</p>
      <div class="buttons">
        <vbutton
          label="invites.repeatedModal.accept"
          :disabled="disabled"
          @click="accept" />
        <vbutton
          label="common.cancel"
          color="white"
          @click="$emit('close')" />
      </div>
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/Modal.vue';
  import Moment from 'moment'

  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index
  }

  export default {
    name: 'invites-creation-repeatedModal',

    props: {
      invites: Array
    },

    components: {
      Modal
    },

    data () {
      return {
        selected: []
      }
    },

    computed: {
      isSelectedAll () {
        return this.invites.every(i => this.selected.includes(i.localId))
      },

      selectedAll: {
        get () {
          if (!this.invites.length) {
            return false
          }
  
          return this.isSelectedAll
        },

        set (val) {
          if (val) {
            const localIds = this.invites
              .map(i => i.localId)
              .filter(onlyUnique)
            this.selected = this.selected.concat(localIds)
          } else {
            this.selected = []
          }
        }
      },

      hint () {
        const count = this.selected.length

        if (!count) {
          return ''
        }

        const start = this.$tr('common.selectedInvites')

        return `${start}: ${count}`
      },

      disabled() {
        return !this.selected || !this.selected.length;
      }
    },

    methods: {
      createdAt (invite) {
        if (invite.created_at) {
          const dateFormat = this.is_japan_locale() ? 'MM.DD' : 'DD.MM'
          return Moment(invite.created_at).format(dateFormat)
        }
        return null
      },

      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },

      manager (invite) {
        if (!invite.user) {
          return ''
        }

        const name = invite.user.name
        const surname = invite.user.surname

        return !this.is_japan_locale ? [name, surname].join(' ') : [surname, name].join(' ')
      },

      deleteRow (localId) {
        this.$emit('deleteRow', localId)

        // Delete last repeated invite
        if (this.invites.length <= 1) {
          this.$emit('close')
        }
      },

      accept () {
        this.$emit('close')
        this.$emit('accept')
      },

      deleteSelected () {
        this.selected.forEach(localId => {
          this.deleteRow(localId)
        })
      }
    },

    mounted() {
      this.selectedAll = true;
    }
  }
</script>

<style lang="scss">
  @import "../../../styles/colors.scss";

  $trhead-color: rgba(0, 0, 0, 0.54);
  $trhead-border: #C4C4C4;
  $span-color: #BDBDBD;

  .invites-repeated-modal {
    // TODO: Need replace these styles by new global redesign modals
    &.modal-mask.redesign .modal-container {
      width: 780px;
      max-width: 95%;
      max-height: none;
      box-sizing: border-box;

      .modal-header { font-size: 24px; }

      .modal-body {
        margin: 14px 0 30px;
        font-size: 16px;
        line-height: 23px;
        
        p { margin: 0;}

        .list-wrapper {
          margin-top: 34px;
          margin-bottom: 15px;

          .cell {
            &.cell-checkbox {
              display: flex;
              justify-content: center;
              padding: 0;
            }

            &.centered {
              text-align: center;
            }
          }
          

          .row-block {
            display: flex;
            align-items: center;

            .cell:nth-child(1) { max-width: 30px; width: 30px; padding: 0; }
            .cell:nth-child(2) { max-width: calc(35% - 30px); width: calc(35% - 30px); }
            .cell:nth-child(3) { max-width: 10%; width: 10%; }
            .cell:nth-child(4) { max-width: 25%; width: 25%; }
            .cell:nth-child(5) { max-width: 30%; width: 30%; }

            .cell { 
              box-sizing: border-box;
            }
          }

          .scrollable {
            max-height: 250px;
            overflow: auto;
            display: block;

            .row-block {
              &:last-child {
                border-bottom: 1px solid $trhead-border;
              }

              .cell {
                font-size: 16px;
                line-height: 24px;
                padding: 3px 5px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                &.cell-checkbox { padding: 0; }
              }
            }
          }

          .header {
            border-bottom: 1px solid $trhead-border;
            .cell {
              color: $trhead-color;
              font-size: 14px;
              line-height: 20px;
              height: initial;
              padding: 0 5px 3px;
            }
          }
        }

        .row-block {
          justify-content: flex-end;
          span { margin-right: 10px; }
        }
      }

      .modal-footer .footer{
        display: flex;
        align-items: center;
        flex-direction: column;

        .buttons {
          display: flex;
        }

        .vbutton {
          margin-left: 0;
          margin-right: 15px;


          p {
            color: $span-color;
            line-height: 20px;
            font-size: 14px;
          }
        }
      }
    }

    .modal-close {
      right: 10px;
      top: 10px;
      width: 20px;
      height: 20px;

      &:before,
      &:after {
        background-color: $text-color;
      }
    }

    .repeated-description {
      color: #DB371D;
    }

    .subscript {
      margin-top: 0;
    }
  }

  .checkbox-block {
    width: 18px;
  }
</style>
